import cx from 'classnames'

import { useGameSlug } from '../../game-provider'

import storefronts from '../storefronts.module.scss'

type SubsectionProps = {
  children: React.ReactNode
  fullWidth?: boolean
}

export const Subsection = ({ children, fullWidth }: SubsectionProps) => {
  const gameSlug = useGameSlug()
  return (
    <div
      className={cx(storefronts[gameSlug], storefronts.subsection, storefronts.desktopWidth, storefronts.topOverlap, {
        [storefronts.fullWidth]: fullWidth,
      })}
    >
      {children}
    </div>
  )
}
